import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import ProformaInvoiceEditLayer from "../components/ProformaInvoiceEditLayer";
import QuotationEditLayer from "../components/QuotationEditLayer";




const QuotationEditPage = () => {
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        {/* <Breadcrumb title="Invoice - Edit" /> */}

        {/* InvoiceEditLayer */}
        <QuotationEditLayer />

      </MasterLayout>

    </>
  );
};

export default QuotationEditPage;
